import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=358a7d30"
import script from "./DownloadBtn.vue?vue&type=script&lang=ts"
export * from "./DownloadBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports